module.exports = require('./PageForm');


/** WEBPACK FOOTER **
 ** ./demo/src/pages/form/index.js
 **/